// "HEPSİNİ TOPLA" — yüzen pencere sahipleri (TasksPanel: görev/alt görev/iş
// kolu pencereleri, Sidebar: ayrılmış sekme pencereleri) buraya kaydolur.
// dnd-kit / react-rnd çekirdeğine dokunulmaz; her sahip KENDİ mevcut
// toplama/açma fonksiyonunu verir.
import { useEffect, useState } from "react";

const kayitlar = new Map(); // id -> { say, kapat, geriAc, yedek? }
const subs = new Set();

const bildir = () => subs.forEach((f) => f(Date.now()));

// Ana Görevler paneli mount ise kategori pencerelerini O sayar; yedek
// toplayıcı (panel kapalıyken devreye giren) devre dışı kalır → çift sayım yok.
const etkinler = () => {
  const hepsi = [...kayitlar.values()];
  const anaVar = hepsi.some((o) => o.ana);
  return anaVar ? hepsi.filter((o) => !o.yedek) : hepsi;
};

// o = { say: () => n, kapat: () => snapshot, geriAc: (snapshot) => void }
export const registerWindowCollector = (id, o) => {
  kayitlar.set(id, o);
  bildir();
  return () => {
    if (kayitlar.get(id) === o) {
      kayitlar.delete(id);
      bildir();
    }
  };
};

export const yuzenPencereSayisi = () =>
  etkinler().reduce((a, o) => {
    try { return a + (o.say?.() || 0); } catch { return a; }
  }, 0);

// Tüm pencereleri panele geri takar; geri alma için anlık görüntü döner.
export const tumPencereleriTopla = () => {
  const snap = [];
  for (const o of etkinler()) {
    try {
      const s = o.kapat?.();
      if (s) snap.push({ o, s });
    } catch (e) {
      console.warn("[windowCollectors] toplama hatası:", e);
    }
  }
  return snap;
};

export const tumPencereleriGeriAc = async (snap) => {
  for (const { o, s } of snap || []) {
    try { await o.geriAc?.(s); } catch (e) { console.warn("[windowCollectors] geri açma hatası:", e); }
  }
};

// Sayı değiştiğinde yeniden render için küçük abonelik kancası.
export const useYuzenPencereSayisi = () => {
  const [n, setN] = useState(yuzenPencereSayisi);
  useEffect(() => {
    const f = () => setN(yuzenPencereSayisi());
    subs.add(f);
    f();
    return () => subs.delete(f);
  }, []);
  return n;
};
